/* EmmetiStore technical highlights 1.0.0. No external requests or dependencies. */
(function () {
  'use strict';
  if (customElements.get('emmeti-tech-specs')) return;
  class EmmetiTechSpecs extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.init()); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      this.limit = Math.max(1, Math.min(24, Number(this.dataset.etsLimit) || 12));
      this.items = [...this.querySelectorAll('[data-ets-item]')].map(node => {
        const data = node.querySelector('[data-ets-data]');
        let variants = null;
        try { if (data) variants = JSON.parse(data.textContent); } catch (_) { variants = {}; }
        return { node, value: node.querySelector('[data-ets-value]'), variants };
      });
      const scope = this.closest('.js-product') || this.closest('.shopify-section') || this.parentElement;
      scope.addEventListener('on:variant:change', event => {
        const detail = event.detail || {};
        if (detail.product && String(detail.product.id) !== this.dataset.productId) return;
        if (event.target.closest('.js-product') !== this.closest('.js-product')) return;
        const id = detail.variant && String(detail.variant.id);
        this.items.forEach(item => {
          if (item.variants === null) return;
          // Payload consists solely of server-escaped text. Decode entities as text.
          const encoded = id && Object.prototype.hasOwnProperty.call(item.variants,id) ? item.variants[id] : '';
          const decoder = document.createElement('textarea');
          decoder.innerHTML = typeof encoded === 'string' ? encoded : '';
          item.value.textContent = decoder.value;
        });
        this.refresh();
      }, { signal:this.controller.signal });
      this.refresh();
    }
    refresh() {
      let visible = 0;
      this.items.forEach(item => { item.node.hidden = !item.value.textContent.trim() || ++visible > this.limit; });
      this.hidden = visible === 0;
      this.dataset.etsCount = String(Math.min(visible,this.limit));
      const scroller = this.querySelector('.ets__scroller');
      scroller.scrollLeft = 0;
    }
    disconnectedCallback() { if (this.controller) this.controller.abort(); this.controller = null; }
  }
  customElements.define('emmeti-tech-specs', EmmetiTechSpecs);
})();
